import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { getI18nFromGeneral } from '@/src/tools/tools';
import React from 'react';
import { Modal, ModalFooter } from 'src/components/Antd';
import Editor from 'src/constrains/BraftEditor';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const _Modal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { salesChannelUuid, data: oriData, onOk, onCancel, visible } = props;
  const [data, setData] = React.useState(oriData);
  React.useEffect(() => {
    if (_editor.current && _editor.current.setData && oriData !== data) {
      _editor.current.setData(oriData);
    }
  }, [oriData]);
  const _editor = React.useRef<any>(null);
  const linkSet = {
    scopeVariables: {
      SalesChannel: salesChannelUuid,
    },
    // linkTypeFilter: [LinkModuleType.LinkLibrary];
  };
  const handleOnOk = () => {
    if (onOk) {
      onOk(data);
    }
  };
  const handleOnContentChange = ({ data, isEmpty }) => {
    setData(data);
  };
  return (
    <Modal
      visible={visible}
      title={getI18n('salesChannelCheckout.index.crossBorderReminder')}
      onCancel={onCancel}>
      <div className={css.modalContainer}>
        <ItemWrapper title={getI18n('general.sider.content')}>
          <Editor
            configFront={['undo', 'redo', 'separator', 'bold']}
            configBack={['code']}
            linkSet={linkSet}
            ref={(e) => (_editor.current = e)}
            id='SalesChannelLegalPageEditorContent'
            data={data}
            onChange={handleOnContentChange}
            contentStyle={{
              height: 210,
              boxShadow: 'inset 0 1px 3px rgba(0,0,0,.1)',
            }}
            //   configFront={configFront}
            //   configBack={configBack}
          />
        </ItemWrapper>
      </div>
      <ModalFooter
        okText={getI18nFromGeneral('general.antd.Modal.ModalFooter.confirm')}
        cancelText={getI18nFromGeneral('general.commonHeader.discard_text')}
        onOk={handleOnOk}
        onCancel={onCancel}
        // hideOkButton={!category || (isDob && !(date.y || date.m || date.d))}
      />
    </Modal>
  );
};
export default _Modal;
